import * as yup from "yup";
import { $enum } from "ts-enum-util";

import {
  CustomerBranchFilterDefault,
  CustomerBranchFilterType
} from "../../api/products.api";

export const createProductReplacementSchema = yup.object().shape({
  replacements: yup.array().of(
    yup.object().shape({
      fromProductId: yup.number(),
      toProductId: yup.number()
    })),
  type: yup.string().oneOf($enum(CustomerBranchFilterDefault).getValues()).required("Default product replacement behaviour is required"),
  orderTypes: yup.array().of(yup.string().oneOf([
    "scheduled",
    "bulk",
    "adhoc"
  ])).required("Order Types are required"),
  filters: yup.array().of(yup.object().shape({
    customerId: yup.number().nullable(),
    branchId: yup.number().nullable(),
    filterType: yup.string().oneOf($enum(CustomerBranchFilterType).getValues()).required()
  })),
  effectOrders: yup.object().shape({
    startDate: yup
      .date()
      .label("Start date")
      .required("Start date is required"),
    endDate: yup
      .date()
      .label("End date")
      .when("startDate", (startDate: Date, schema: yup.DateSchema) => {
        if (startDate) {
          return schema.min(startDate);
        } else {
          return schema;
        }
      })
  }),
  effectLists: yup.boolean().required()
});
